import {
    GET_AUTH_UTILIZATION,
    CREATE_CLIENT,
    CREATE_CLIENT_CONTACT,
    CREATE_CLIENT_ENROLLMENT,
    DELETE_CLIENT,
    DELETE_CLIENT_CONTACT,
    DELETE_CLIENT_ENROLLMENT,
    EDIT_CLIENT,
    EDIT_CLIENT_AUTHORIZATION,
    EDIT_CLIENT_CONTACT,
    EDIT_CLIENT_ENROLLMENT,
    GET_CLIENT_BY_ID,
    GET_CLIENT_CONTACTS,
    GET_CLIENT_ENROLLMENT,
    GET_CLIENTS,
    ADD_FILES_TO_CLIENT_AUTH,
    REMOVE_FILES_FROM_CLIENT_AUTH,
    TERMINATE_CLIENT_ENROLLMENT,
    EDIT_FILE_NAME_OF_CLIENT_AUTH,
    CHANGE_ENROLLMENT_TYPE,
    ADD_CLIENT_ADDRESS,
    EDIT_CLIENT_ADDRESS,
    DELETE_CLIENT_ADDRESS,
    GET_CLIENT_SCHEDULING_ADDRESS,
    SET_CLIENT_SCHEDULING_ADDRESS,
    CLEAR_CLIENT_SCHEDULING_ADDRESS,
    ASSIGN_STAFF,
    GET_ASSIGNED_STAFFS,
    REMOVE_STAFF,
    EDIT_CLIENT_STATUS,
    EDIT_ASSIGNED_STAFF,
    GET_BASIC_CLIENTS,
    GET_BASIC_ACTIVE_CLIENTS,
    GET_AUTH_UNIT_INFO,
    ADD_CLIENT_AUTHORIZATION,
    GET_CLIENT_AUTHORIZATIONS,
    INACTIVATE_CLIENT_AUTHORIZATION,
    CANCEL_CLIENT_AUTHORIZATION,
    DELETE_CLIENT_AUTHORIZATION,
    DELETE_AUTHORIZED_SERVICE,
    CLIENT_AUTHORIZATION_VISIBLE,
    GITE_CLIENT_AUTH_FILES,
    GET_CLIENT_AUTHORIZATIONS_APPT,
    GET_CLIENT_FORMS,
    DELETE_CLIENT_FORM,
    ADD_CLIENT_FORM,
    GET_ENROLLMENT_PAYERS,
    RESEND_CLIENT_INVITE,
    GET_CLIENT_CONTACTS_INFO,
    CREATE_CLIENT_INTAKE_FORM,
    GET_CLIENT_SECTIONS,
    CREATE_CLIENT_SECTION,
    EDIT_CLIENT_SECTION,
    DELETE_CLIENT_SECTION,
    LINK_CONTACT_TO_CLIENT,
    GRANT_PORTAL_ACCESS,
    REVOKE_PORTAL_ACCESS,
    SET_CLIENT_CONTACT_PASSWORD,
    REMOVE_CLIENT_AUTHORIZATIONS,
    GET_CLIENTS_EXPIRATION,
    GET_CLIENT_ALL_NOTES,
    DELETE_CLIENT_NOTES,
} from './client.types';

export const getClients = (data, load) => {
    return {
        type: GET_CLIENTS,
        payload: { data, load },
    };
};
export const getClientExpiration = (params) => {
    return {
        type: GET_CLIENTS_EXPIRATION,
        payload: { params },
    };
};
export const getBasicClients = (params) => {
    return {
        type: GET_BASIC_CLIENTS,
        payload: { params },
    };
};
export const getBasicActiveClients = (params) => {
    return {
        type: GET_BASIC_ACTIVE_CLIENTS,
        payload: { params },
    };
};

export const createClient = (body) => {
    return {
        type: CREATE_CLIENT,
        payload: { body },
    };
};

export const createIntakeForm = (body) => {
    return {
        type: CREATE_CLIENT_INTAKE_FORM,
        payload: { body },
    };
};

export const resendClientInvite = (id, params) => {
    return {
        type: RESEND_CLIENT_INVITE,
        payload: { id, params },
    };
};

export const deleteClient = (id) => {
    return {
        type: DELETE_CLIENT,
        payload: { id },
    };
};

export const editClient = (body, id) => {
    return {
        type: EDIT_CLIENT,
        payload: { body, id },
    };
};

export const editClientStatus = (id, status) => {
    return {
        type: EDIT_CLIENT_STATUS,
        payload: { id, status },
    };
};

export const getClientsById = (id, load) => {
    return {
        type: GET_CLIENT_BY_ID,
        payload: { id, load },
    };
};

export const getClientsContacts = (id, data) => {
    return {
        type: GET_CLIENT_CONTACTS,
        payload: { id, data },
    };
};
export const getClientsContactInfo = (id, data) => {
    return {
        type: GET_CLIENT_CONTACTS_INFO,
        payload: { id, data },
    };
};

export const createClientContact = (body, id) => {
    return {
        type: CREATE_CLIENT_CONTACT,
        payload: { body, id },
    };
};

export const editClientContact = (body, id, paramsId) => {
    return {
        type: EDIT_CLIENT_CONTACT,
        payload: { body, id, paramsId },
    };
};

export const deleteClientContact = (id, paramsId) => {
    return {
        type: DELETE_CLIENT_CONTACT,
        payload: { id, paramsId },
    };
};

/** Client Enrollment */

export const getEnrollmentPayers = (id) => {
    return {
        type: GET_ENROLLMENT_PAYERS,
        payload: { id },
    };
};
export const getClientsEnrollment = (id, params, load) => {
    return {
        type: GET_CLIENT_ENROLLMENT,
        payload: { id, params, load },
    };
};

export const createClientEnrollment = (body, id, funderId) => {
    return {
        type: CREATE_CLIENT_ENROLLMENT,
        payload: { body, id, funderId },
    };
};

export const editClientEnrollment = (body, id) => {
    return {
        type: EDIT_CLIENT_ENROLLMENT,
        payload: { body, id },
    };
};

export const terminateClientEnrollment = (clientId, enrollmentId, body) => {
    return {
        type: TERMINATE_CLIENT_ENROLLMENT,
        payload: { clientId, enrollmentId, body },
    };
};

export const deleteClientEnrollment = (id, clientId) => {
    return {
        type: DELETE_CLIENT_ENROLLMENT,
        payload: { id, clientId },
    };
};

export const changeEnrollmentType = (info) => {
    return {
        type: CHANGE_ENROLLMENT_TYPE,
        payload: info,
    };
};

/** End */

/** Client Address */
export const addAddress = (id, body) => {
    return {
        type: ADD_CLIENT_ADDRESS,
        payload: { id, body },
    };
};

export const editAddress = (id, addressId, body) => {
    return {
        type: EDIT_CLIENT_ADDRESS,
        payload: { id, addressId, body },
    };
};

export const deleteAddress = (id, addressId) => {
    return {
        type: DELETE_CLIENT_ADDRESS,
        payload: { id, addressId },
    };
};
/** End */

/** Client Scheduling Address */
export const getSchedulingAddress = (id) => {
    return {
        type: GET_CLIENT_SCHEDULING_ADDRESS,
        payload: { id },
    };
};

/** body: { type, refId, name? } */
export const setSchedulingAddress = (id, body) => {
    return {
        type: SET_CLIENT_SCHEDULING_ADDRESS,
        payload: { id, body },
    };
};

export const clearSchedulingAddress = (id) => {
    return {
        type: CLEAR_CLIENT_SCHEDULING_ADDRESS,
        payload: { id },
    };
};
/** End */

/** Staff Assignment */
export const assignStaff = (body) => {
    return {
        type: ASSIGN_STAFF,
        payload: { body },
    };
};

export const editAssignedStaff = (id, body, clientId) => {
    return {
        type: EDIT_ASSIGNED_STAFF,
        payload: { id, body, clientId },
    };
};

export const getAssignedStaffs = (id) => {
    return {
        type: GET_ASSIGNED_STAFFS,
        payload: { id },
    };
};

export const removeClientStaff = (clientId, staffId) => {
    return {
        type: REMOVE_STAFF,
        payload: { clientId, staffId },
    };
};
/** End */

/** Client Authorization */

export const addClientAuthorization = (id, body) => {
    return {
        type: ADD_CLIENT_AUTHORIZATION,
        payload: { id, body },
    };
};
export const editClientAuthorization = (clientId, body) => {
    return {
        type: EDIT_CLIENT_AUTHORIZATION,
        payload: { clientId, body },
    };
};

export const inactivateClientAuthorization = (id, clientId, reason) => {
    return {
        type: INACTIVATE_CLIENT_AUTHORIZATION,
        payload: { id, clientId, reason },
    };
};

export const cancelClientAuthorization = (clientId, authorizationUniqueId, payerId, reason) => {
    return {
        type: CANCEL_CLIENT_AUTHORIZATION,
        payload: { clientId, authorizationUniqueId, payerId, reason },
    };
};

export const deleteClientAuthorization = (clientId, authorizationUniqueId, payerId) => {
    return {
        type: DELETE_CLIENT_AUTHORIZATION,
        payload: { clientId, authorizationUniqueId, payerId },
    };
};

export const deleteAuthorizedService = (id, clientId) => {
    return {
        type: DELETE_AUTHORIZED_SERVICE,
        payload: { id, clientId },
    };
};

export const clientAuthorizationVisible = (id, clientId, isApptVisible) => {
    return {
        type: CLIENT_AUTHORIZATION_VISIBLE,
        payload: { id, clientId, isApptVisible },
    };
};

/** `load: 'noLoad'` refreshes in place, without the tab-wide loader. */
export const getClientAuthorization = (clientId, load) => {
    return {
        type: GET_CLIENT_AUTHORIZATIONS,
        payload: { clientId, load },
    };
};
/** `params.skip` 0 replaces the loaded clients; a larger skip appends the next page. */
export const getAuthUtilization = (params) => {
    return {
        type: GET_AUTH_UTILIZATION,
        payload: { params },
    };
};

export const removeClientAuthorization = () => {
    return {
        type: REMOVE_CLIENT_AUTHORIZATIONS,
    };
};

export const getClientAuthorizationAppt = (clientId, reqType, showExpired) => {
    return {
        type: GET_CLIENT_AUTHORIZATIONS_APPT,
        payload: { clientId, reqType, showExpired },
    };
};

export const getClientsAuthorizationsAppt = (authId, status, load) => {
    return {
        type: GET_AUTH_UNIT_INFO,
        payload: { authId, status, load },
    };
};

export const getClientAuthFiles = (clientId, params) => {
    return {
        type: GITE_CLIENT_AUTH_FILES,
        payload: { clientId, params },
    };
};

export const addFilesToClientAuth = (clientId, params, files) => {
    return {
        type: ADD_FILES_TO_CLIENT_AUTH,
        payload: { clientId, params, files },
    };
};

export const editFileNameOfClientAuth = (clientId, params, docId, fileName) => {
    return {
        type: EDIT_FILE_NAME_OF_CLIENT_AUTH,
        payload: { clientId, params, docId, fileName },
    };
};

export const removeFilesFromClientAuth = (clientId, params, docId) => {
    return {
        type: REMOVE_FILES_FROM_CLIENT_AUTH,
        payload: { clientId, params, docId },
    };
};

/** End */

/** Link Contact */
export const linkContactToClient = (contactId, clientId, grantPortalAccess) => {
    return {
        type: LINK_CONTACT_TO_CLIENT,
        payload: { contactId, clientId, grantPortalAccess },
    };
};

/** Portal Access */
export const grantPortalAccess = (clientId, contactId) => {
    return {
        type: GRANT_PORTAL_ACCESS,
        payload: { clientId, contactId },
    };
};

export const revokePortalAccess = (clientId, contactId) => {
    return {
        type: REVOKE_PORTAL_ACCESS,
        payload: { clientId, contactId },
    };
};

export const setClientContactPassword = (id, body, clientId) => {
    return {
        type: SET_CLIENT_CONTACT_PASSWORD,
        payload: { id, body, clientId },
    };
};
/** End */

/** Forms */

export const getClientForms = (clientId, params, load) => {
    return {
        type: GET_CLIENT_FORMS,
        payload: { clientId, params, load },
    };
};
export const deleteClientForms = (clientId, formId) => {
    return {
        type: DELETE_CLIENT_FORM,
        payload: { clientId, formId },
    };
};
export const addClientForms = (clientId, params) => {
    return {
        type: ADD_CLIENT_FORM,
        payload: { clientId, params },
    };
};
/** End */

/** Client Sections */

export const getClientSections = (clientId) => {
    return {
        type: GET_CLIENT_SECTIONS,
        payload: { clientId },
    };
};

export const createClientSection = (clientId, body) => {
    return {
        type: CREATE_CLIENT_SECTION,
        payload: { clientId, body },
    };
};

export const editClientSection = (clientId, sectionId, body) => {
    return {
        type: EDIT_CLIENT_SECTION,
        payload: { clientId, sectionId, body },
    };
};

export const deleteClientSection = (clientId, sectionId) => {
    return {
        type: DELETE_CLIENT_SECTION,
        payload: { clientId, sectionId },
    };
};

/** End */

/** Client Documentation Notes */
export const getClientAllNotes = (params, clientId, load) => {
    return {
        type: GET_CLIENT_ALL_NOTES,
        payload: { params, clientId, load },
    };
};

export const deleteClientAllNotes = (docId, clientId, requestParams) => {
    return {
        type: DELETE_CLIENT_NOTES,
        payload: { docId, clientId, requestParams },
    };
};
/** End */
